export default __webpack_public_path__ + "static/media/img-2.9ad853b2.jpg";